<script setup>
const { $isMobile } = useNuxtApp();

definePageMeta({
	"m-showNavBar": true,
	"m-showFooter": true,
	"pc-showNavBar": true,
	"pc-showFooter": true,
	breadcrumbName: "首頁",
});

useHead({
	title: "先知命局，陪你找到人生方向",
	meta: [
		{ name: "keywords", content: "八字算命，八字排盤，名字算命" },
		{
			name: "description",
			content:
				"先知命局是一個面向全球的命理文化平台，專注於八字算命與八字排盤服務，讓您了解自己命格的深層意義。專業分析將幫助您預測未來運勢，提供事業、健康、財富等方面的指引，助您順利度過人生每個階段。",
		},
	],
});

const DynamicComponent = $isMobile
	? defineAsyncComponent(() => import("@variants/index/m/index.vue"))
	: defineAsyncComponent(() => import("@variants/index/pc/index.vue"));
</script>

<template>
	<DynamicComponent />
</template>

<style lang="scss">
body {
	background: #fff;
}
</style>
